import {Component, computed, inject, input} from '@angular/core';
import {ApartmentDto} from "homey-housing-lottery-app-dto";
import {CarouselModule} from "primeng/carousel";
import {SharedModule} from "primeng/api";
import {ApartmentAddressPipe} from "../pipes/apartment-address.pipe";
import {RouterLink} from "@angular/router";
import {RelevantApartmentsInput} from "../pipes/apartment-relevant-advertisements.pipe";
import {DatePipe, NgClass} from "@angular/common";
import {CombineArraysPipe} from "../pipes/combine-arrays.pipe";
import {ABService} from "../services/a-b.service";
import {TranslocoPipe} from "@jsverse/transloco";
import {HomeyImageDirective} from "../directives/homey-image.directive";
import {RentDisplayComponent} from "../components/rent-display/rent-display.component";

@Component({
  selector: 'homey-lotteries-carousel',
  standalone: true,
  imports: [
    CarouselModule,
    SharedModule,
    ApartmentAddressPipe,
    RouterLink,
    DatePipe,
    CombineArraysPipe,
    NgClass,
    TranslocoPipe,
    HomeyImageDirective,
    RentDisplayComponent
  ],
  templateUrl: './lotteries-carousel.component.html',
  styleUrl: './lotteries-carousel.component.scss'
})
export class LotteriesCarouselComponent {
  link = input<boolean>(true);
  showPrice = input<boolean>(true);
  apartmentRoute = input<string[]>(['apartments']);
  lotteries = input.required<ApartmentDto[]>();
  lotteriesCarouselData = computed(() => this.lotteries().map(lottery => ({
    id: lottery.id,
    name: lottery.name,
    image: lottery.mainPhoto.baseImage,
    addressInfo: lottery.addressInfo,
    type: lottery.type,
    unitTypes: lottery.unitTypes,
    endDate: lottery.endDate,
  })));
  relevantApartmentsInput = input.required<RelevantApartmentsInput>();
  queryParams = computed(() => {
    const input = this.relevantApartmentsInput();

    if (input.type === 'user') {
      return {}
    } else if (input.type === 'all') {
      return {}
    }else{
      return {
        size: input.householdSize,
        lowerIncome: input.lowerHouseholdIncome,
        upperIncome: input.upperHouseholdIncome
      }
    }
  });

  abService = inject(ABService);
  protected readonly lotteryCarousel = this.abService.lotteryCarousel;
}
